import { api } from './api';

/**
 * Frontend-facing shape of `GET /v2/equipment-catalog/hvac`. Declared locally with string ids, as
 * the AVL admin service does, so the form does not couple to the server document types.
 */
export interface EquipmentCatalogBrand {
  id: string;
  name: string;
  websiteUrl?: string;
  warrantyRegistrationUrl?: string;
}

export interface EquipmentCatalogManufacturer {
  id: string;
  name: string;
  brands: EquipmentCatalogBrand[];
}

export interface HvacEquipmentCatalogResponse {
  manufacturers: EquipmentCatalogManufacturer[];
}

export const equipmentCatalogApi = api.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Tagged on the manufacturer list rather than a tag of its own: every phase 1 admin mutation
     * already invalidates that tag, so an edit in the portal refreshes the picker's options too.
     */
    getHvacEquipmentCatalog: build.query<HvacEquipmentCatalogResponse, void>({
      query: () => ({ url: '/v2/equipment-catalog/hvac' }),
      providesTags: [{ type: 'EquipmentManufacturers', id: 'LIST' }],
    }),
  }),
});

export const { useGetHvacEquipmentCatalogQuery } = equipmentCatalogApi;
